import { docReady } from './utils';
import navbarInit from './bootstrap-navbar';
import detectorInit from './detector';
import scrollToTop from './scroll-to-top';
import './horarios';
import whatsappInit from './whatsapp';
import './cta';

const heroVideoInit = () => {
  const modalEl = document.getElementById('popupVideo');
  const videoEl = document.getElementById('heroVideo');
  if (!modalEl || !videoEl) return;

  modalEl.addEventListener('show.bs.modal', () => {
    videoEl.currentTime = 0;
    const playPromise = videoEl.play();
    if (playPromise && playPromise.catch) playPromise.catch(() => {});
  });

  modalEl.addEventListener('hidden.bs.modal', () => {
    videoEl.pause();
    videoEl.currentTime = 0;
  });
};

// /* -------------------------------------------------------------------------- */
// /*                            Theme Initialization                            */
// /* -------------------------------------------------------------------------- */

docReady(navbarInit);
docReady(detectorInit);
docReady(scrollToTop);
docReady(heroVideoInit);
docReady(whatsappInit);
